import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { verifyAdminToken } from '../api/api';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const [status, setStatus] = useState(token ? 'checking' : 'unauthorized');

  useEffect(() => {
    let isMounted = true;

    const validateToken = async () => {
      if (!token) {
        if (isMounted) {
          setStatus('unauthorized');
        }
        return;
      }

      try {
        await verifyAdminToken();
        if (isMounted) {
          setStatus('authorized');
        }
      } catch (_error) {
        localStorage.removeItem('token');
        if (isMounted) {
          setStatus('unauthorized');
        }
      }
    };

    validateToken();

    return () => {
      isMounted = false;
    };
  }, [token]);

  if (status === 'checking') {
    return <div style={{ padding: '24px', textAlign: 'center' }}>Checking admin access...</div>;
  }

  if (status !== 'authorized') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;